import { useQuery } from '@tanstack/react-query';
import { messagingService } from 'v2/services/messaging';

export const useSelectedChat = (id?: number) => {
  const { data, isLoading, isFetching, error, refetch } = useQuery({
    queryKey: ['messages', 'chats', id ?? 0],
    queryFn: () => messagingService.getMessagesChat(id ?? 0),
    enabled: !!id,
    refetchInterval: 15_000,
    refetchOnWindowFocus: true,
    refetchOnMount: true
  });

  return {
    messages: data?.data || [],
    isLoading,
    isFetching,
    error,
    refetch
  };
};
